const defaultAppTitle = 'David Walker - Freelance Frontend Developer based in Leeds'

export {
    defaultAppTitle
}


// WEBPACK FOOTER //
// ./src/config/functions.js